const documentContentStyle = `
  body {
    font-size: 12pt;
    font-family: "Times New Roman", Times, serif;
    line-height: normal;
    background: #fff;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: "Times New Roman", Times, serif;
    font-size: 12pt;
    line-height: normal;
  }
  table {
    border-collapse: collapse;
  }
`;

export const tinyMceScriptSrc = "/tinymce/tinymce.min.js";

export const fullTinyMceConfig = {
  base_url: "/tinymce",
  suffix: ".min",
  height: 720,
  min_height: 420,
  menubar: "file edit view insert format tools table help",
  menu: {
    file: {
      title: "File",
      items: "newdocument restoredraft | preview",
    },
    edit: {
      title: "Edit",
      items: "undo redo | cut copy paste pastetext | selectall | searchreplace",
    },
    view: {
      title: "View",
      items: "code | visualaid visualchars visualblocks | preview fullscreen",
    },
    insert: {
      title: "Insert",
      items:
        "image media link anchor codesample inserttable | charmap emoticons hr | pagebreak nonbreaking insertdatetime",
    },
    format: {
      title: "Format",
      items:
        "bold italic underline strikethrough superscript subscript codeformat | formats blocks fontfamily fontsize align lineheight | forecolor backcolor | removeformat",
    },
    tools: {
      title: "Tools",
      items: "code wordcount",
    },
    table: {
      title: "Table",
      items:
        "inserttable | cell row column | advtablesort | tableprops deletetable",
    },
    help: {
      title: "Help",
      items: "help",
    },
  },
  plugins:
    "advlist anchor autolink autosave charmap code codesample directionality emoticons fullscreen help image insertdatetime link lists media nonbreaking pagebreak preview quickbars searchreplace table visualblocks visualchars wordcount",
  toolbar: [
    "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor removeformat",
    "alignleft aligncenter alignright alignjustify | lineheight | bullist numlist outdent indent | ltr rtl",
    "link image media table | charmap emoticons insertdatetime pagebreak nonbreaking anchor | searchreplace code preview fullscreen help",
  ].join(" | "),
  toolbar_mode: "sliding",
  toolbar_location: "top",
  toolbar_sticky: true,
  toolbar_sticky_offset: 0,
  quickbars_selection_toolbar:
    "bold italic underline | quicklink h2 h3 blockquote | forecolor backcolor",
  quickbars_insert_toolbar: "quickimage quicktable",
  contextmenu: "link image table",
  branding: false,
  promotion: false,
  statusbar: true,
  resize: true,
  browser_spellcheck: true,
  paste_data_images: true,
  image_advtab: true,
  link_default_target: "_blank",
  table_toolbar:
    "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
  autosave_ask_before_unload: true,
  autosave_interval: "30s",
  autosave_retention: "20m",
  content_style: documentContentStyle,
};
